import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { DEFAULT_STATSIG_EXPERIMENT_CONFIG, DEFAULT_STATSIG_PARALLEL_EXPERIMENTS_CONFIG, STATSIG_SEARCH_BACKEND_FEATURE_GATE_L1_STANDARD_VS_PREMIUM, STATSIG_SEARCH_BACKEND_FEATURE_GATE_L2_STANDARD_VS_PREMIUM, STATSIG_SEARCH_BACKEND_FEATURE_GATE_L3_ENABLED, STATSIG_SEARCH_BACKEND_FEATURE_GATE_QUERY_EXPANSION_ENABLED, STATSIG_SEARCH_BACKEND_L1_LAYER_PREMIUM, STATSIG_SEARCH_BACKEND_L1_LAYER_STANDARD, STATSIG_SEARCH_BACKEND_L2_BLENDING_LAYER, STATSIG_SEARCH_BACKEND_L2_LAYER_PREMIUM, STATSIG_SEARCH_BACKEND_L2_LAYER_STANDARD, STATSIG_SEARCH_BACKEND_L3_LAYER, STATSIG_SEARCH_BACKEND_LAYER, STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER } from '../../constants';
export var getBackendExperimentConfig = function getBackendExperimentConfig(onErrorFn) {
  var isRequestDrivenExperimentationEnabled = FeatureGates.checkGate('request_driven_experimentation_enabled');
  if (!isRequestDrivenExperimentationEnabled) {
    return;
  }
  var isParallelBackendExperimentationEnabled = FeatureGates.checkGate('run_multiple_layer_models_in_parallel');
  if (isParallelBackendExperimentationEnabled) {
    return getParallelBackendExperimentsConfig(onErrorFn);
  }
  return getSingleBackendExperimentConfig(onErrorFn);
};
var getSingleBackendExperimentConfig = function getSingleBackendExperimentConfig(onErrorFn) {
  var response = _objectSpread({}, DEFAULT_STATSIG_EXPERIMENT_CONFIG);
  try {
    var layer = FeatureGates.getLayer(STATSIG_SEARCH_BACKEND_LAYER);
    for (var _i = 0, _Object$entries = Object.entries(response); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      response[key] = layer.get(key, value);
    }
  } catch (error) {
    onErrorFn === null || onErrorFn === void 0 || onErrorFn(error);
  }
  return response;
};
var getLayerValues = function getLayerValues(layerName) {
  var layer = FeatureGates.getLayer(layerName);
  var layerNameWithoutSuffix = layerName.replace('_standard', '').replace('_premium', '');
  return {
    name: layerNameWithoutSuffix,
    layerId: layer.get('layerId', null),
    shadowId: layer.get('shadowId', null),
    // The below values might not be sent to the backend, but we can still track them in the frontend.
    controlId: layer.get('controlId', null),
    abTestId: layer.get('abTestId', null)
  };
};
var getStandardOrPremiumLayerValues = function getStandardOrPremiumLayerValues(featureGateName, standardLayerName, premiumLayerName) {
  var isPremium = FeatureGates.checkGate(featureGateName);
  if (isPremium) {
    return getLayerValues(premiumLayerName);
  }
  return getLayerValues(standardLayerName);
};
var getParallelBackendExperimentsConfig = function getParallelBackendExperimentsConfig(onErrorFn) {
  var isRequestDrivenExperimentationEnabled = FeatureGates.checkGate('request_driven_experimentation_enabled');
  if (!isRequestDrivenExperimentationEnabled) {
    return;
  }
  try {
    var allLayers = [];
    var layer1 = getStandardOrPremiumLayerValues(STATSIG_SEARCH_BACKEND_FEATURE_GATE_L1_STANDARD_VS_PREMIUM, STATSIG_SEARCH_BACKEND_L1_LAYER_STANDARD, STATSIG_SEARCH_BACKEND_L1_LAYER_PREMIUM);
    allLayers.push(layer1);
    var layer2 = getStandardOrPremiumLayerValues(STATSIG_SEARCH_BACKEND_FEATURE_GATE_L2_STANDARD_VS_PREMIUM, STATSIG_SEARCH_BACKEND_L2_LAYER_STANDARD, STATSIG_SEARCH_BACKEND_L2_LAYER_PREMIUM);
    allLayers.push(layer2);
    var layer2Blending = getLayerValues(STATSIG_SEARCH_BACKEND_L2_BLENDING_LAYER);
    allLayers.push(layer2Blending);
    var isLayer3Enabled = FeatureGates.checkGate(STATSIG_SEARCH_BACKEND_FEATURE_GATE_L3_ENABLED);
    if (isLayer3Enabled) {
      var layer3 = getLayerValues(STATSIG_SEARCH_BACKEND_L3_LAYER);
      allLayers.push(layer3);
    }
    var isQueryExpansionLayerEnabled = FeatureGates.checkGate(STATSIG_SEARCH_BACKEND_FEATURE_GATE_QUERY_EXPANSION_ENABLED);
    if (isQueryExpansionLayerEnabled) {
      var layerQueryExpansion = getLayerValues(STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER);
      allLayers.push(layerQueryExpansion);
    }
    var concatenatedExperimentId = allLayers.map(function (l) {
      return l === null || l === void 0 ? void 0 : l.layerId;
    }).join('_');
    var concatenatedShadowExperimentId = allLayers.map(function (l) {
      return l === null || l === void 0 ? void 0 : l.shadowId;
    }).join('_');
    return {
      experimentId: concatenatedExperimentId,
      shadowExperimentId: concatenatedShadowExperimentId,
      experimentLayers: allLayers
    };
  } catch (error) {
    onErrorFn === null || onErrorFn === void 0 || onErrorFn(error);
  }
  return DEFAULT_STATSIG_PARALLEL_EXPERIMENTS_CONFIG;
};